<template>

  <div class="menu">
    <div>
      <LogoElement />
      <MenuListWidget />
    </div>
    <div>
      <MenuGlobalWidget />
    </div>
  </div>

</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { MenuGlobalWidget, MenuListWidget } from '@shared/components/widgets';
import { LogoElement } from '@shared/components/elements';

export default defineComponent({
  name: 'MenuTemplate',
  components: {
    LogoElement,
    MenuListWidget,
    MenuGlobalWidget,
  },
});

</script>

<style lang="scss" scoped>

  .menu{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100vh;
  }

</style>
